// extracted from https://github.com/gamechanger/androdyssey/blob/99acb398bca3dfba83da2eff437105cdb0603565/app/src/main/java/com/gc/androdyssey/data/models/stats/StatCat.kt
export const BOXSCORE_STAT_CATEGORIES = {
    BATTING: { names: ['AB', 'R', 'H', 'RBI', 'BB', 'SO'], category: 'offense' },
    BATTING_EXTRA: {
        names: ['2B', '3B', 'HR', 'TB', 'HBP', 'SHF', 'SB', 'CS'],
        category: 'offense',
    },

    PITCHING: {
        names: ['IP', 'H', 'R', 'ER', 'BB', 'SO'],
        category: 'defense',
    },

    PITCHING_EXTRA: { names: ['WP', 'HBP', '#P', 'TS', 'BF'], category: 'defense' },
    FIELDING_EXTRA: { names: ['E'], category: 'defense' },
} as const;
